import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--product",
  "use": "icon-arrow--product-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-arrow--product\"><circle cx=\"15\" cy=\"15\" r=\"15\" fill=\"#00856F\" /><path d=\"M16.485 9a.72.72 0 0 0-.665.892c.035.138.11.263.215.358l4.395 4.026H8.961c-.024 0 .685-.002.66 0a.748.748 0 0 0-.683.755c.02.376.38.7.758.681H20.43l-4.395 4.018a.718.718 0 1 0 .975 1.055l5.76-5.267a.718.718 0 0 0 0-1.055l-5.76-5.268a.72.72 0 0 0-.525-.194Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol